import Quiz from "./Quiz";

const QuizView = (props) => {
  const { id, title, questions, options, answers, contents } = props;
  return (
    <>
      <div className="container mx-auto">
        <div className="bg-cyan-500 px-6 py-4 md:px-10 md:py-8">
          <h1 className="break-keep md:text-5xl text-3xl leading-tight text-white font-bold">
            {title}
          </h1>
          <h3 className="mt-6 break-keep text-white">
            {contents &&
              contents.map((v, i) => <p key={`content_${id}_${i}`}>{v}</p>)}
          </h3>
        </div>
        <div className="border-t border-zinc-200 bg-white md:p-8 shadow flex flex-col gap-6">
          {questions &&
            questions.length > 0 &&
            questions.map(({ content, type }, i) => {
              return (
                <div key={`q_${i}`}>
                  <Quiz
                    {...{
                      n: i + 1,
                      option:
                        type === "text" || type === "textarea"
                          ? options[i].content
                          : "",
                      options:
                        type === "text" || type === "textarea"
                          ? [{ content: "" }]
                          : options[i].content,
                      q: content,
                      answers: answers[i],
                      readOnly: true,
                      type: type,
                    }}
                  />
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default QuizView;
